/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  BillingV1QuoteRequestQuotesCreatePathParameters,
  BillingV1QuoteRequestsDestroyPathParameters,
  BillingV1QuoteRequestsListParams,
  BillingV1QuoteRequestsRetrievePathParameters,
  CursorPaginatedQuoteRequestResponseV1,
  QuoteCreateRequestV1Request,
  QuoteRequestCreateRequestV1Request,
  QuoteRequestReceiptResponseV1,
  QuoteRequestResponseV1,
  QuoteRequestStatusResponseV1,
  QuoteResponseV1
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class BillingQuoteRequestService {
  private readonly http = inject(HttpClient);
/**
 * Admin-only (M-bill-19). `?attended=false` is the inbox: the requests no quote was created from.
 * @summary List the quote requests of the landing (cursor-paginated), newest first.
 */
 billingV1QuoteRequestsList<TData = CursorPaginatedQuoteRequestResponseV1>(params?: BillingV1QuoteRequestsListParams, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteRequestsList<TData = CursorPaginatedQuoteRequestResponseV1>(params?: BillingV1QuoteRequestsListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteRequestsList<TData = CursorPaginatedQuoteRequestResponseV1>(params?: BillingV1QuoteRequestsListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteRequestsList<TData = CursorPaginatedQuoteRequestResponseV1>(
    params?: BillingV1QuoteRequestsListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/quote_requests/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/quote_requests/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v1/billing/quote_requests/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * No login (M-bill-19). The landing sends the contact, the commune, a message, 1 to 20 works with the rules of a new draft work of a quote, the identity of the privacy policy version the form showed, and a Cloudflare Turnstile token, checked before anything is saved. At most 5 per hour per client IP (429). The response says only that the request was saved.
 * @summary Ask for a quote from the landing (public).
 */
 billingV1QuoteRequestsCreate<TData = QuoteRequestReceiptResponseV1>(quoteRequestCreateRequestV1Request: QuoteRequestCreateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteRequestsCreate<TData = QuoteRequestReceiptResponseV1>(quoteRequestCreateRequestV1Request: QuoteRequestCreateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteRequestsCreate<TData = QuoteRequestReceiptResponseV1>(quoteRequestCreateRequestV1Request: QuoteRequestCreateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteRequestsCreate<TData = QuoteRequestReceiptResponseV1>(
    quoteRequestCreateRequestV1Request: QuoteRequestCreateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/quote_requests/`,
      quoteRequestCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/quote_requests/`,
      quoteRequestCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/quote_requests/`,
      quoteRequestCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only (M-bill-19). A request is never edited: it is the record of what the prospect sent.
 * @summary Get one quote request, with its works as the prospect sent them.
 */
 billingV1QuoteRequestsRetrieve<TData = QuoteRequestResponseV1>(pathParams: BillingV1QuoteRequestsRetrievePathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteRequestsRetrieve<TData = QuoteRequestResponseV1>(pathParams: BillingV1QuoteRequestsRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteRequestsRetrieve<TData = QuoteRequestResponseV1>(pathParams: BillingV1QuoteRequestsRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteRequestsRetrieve<TData = QuoteRequestResponseV1>(
    { identity }: BillingV1QuoteRequestsRetrievePathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/quote_requests/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/quote_requests/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/billing/quote_requests/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only (M-bill-19). 204 with no body. A quote created from it keeps its own copies of the works.
 * @summary Delete a quote request with its works.
 */
 billingV1QuoteRequestsDestroy<TData = void>(pathParams: BillingV1QuoteRequestsDestroyPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteRequestsDestroy<TData = void>(pathParams: BillingV1QuoteRequestsDestroyPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteRequestsDestroy<TData = void>(pathParams: BillingV1QuoteRequestsDestroyPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteRequestsDestroy<TData = void>(
    { identity }: BillingV1QuoteRequestsDestroyPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v1/billing/quote_requests/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v1/billing/quote_requests/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v1/billing/quote_requests/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only (M-bill-19). The body is the one of POST /v1/billing/quotes/ (the front fills it in from the request). The quote gets a copy of each work of the request, adjusted on the quote; the request keeps its works as the prospect sent them. A request whose quote still exists is a 409; deleting that quote leaves the request unattended again.
 * @summary Create the quote of a landing quote request.
 */
 billingV1QuoteRequestQuotesCreate<TData = QuoteResponseV1>(pathParams: BillingV1QuoteRequestQuotesCreatePathParameters,
    quoteCreateRequestV1Request: QuoteCreateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteRequestQuotesCreate<TData = QuoteResponseV1>(pathParams: BillingV1QuoteRequestQuotesCreatePathParameters,
    quoteCreateRequestV1Request: QuoteCreateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteRequestQuotesCreate<TData = QuoteResponseV1>(pathParams: BillingV1QuoteRequestQuotesCreatePathParameters,
    quoteCreateRequestV1Request: QuoteCreateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteRequestQuotesCreate<TData = QuoteResponseV1>(
    { identity }: BillingV1QuoteRequestQuotesCreatePathParameters,
    quoteCreateRequestV1Request: QuoteCreateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/quote_requests/${identity}/quotes/`,
      quoteCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/quote_requests/${identity}/quotes/`,
      quoteCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/quote_requests/${identity}/quotes/`,
      quoteCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only (M-bill-19), for the badge of the admin menu. Same shape as `GET /v1/legal/acceptances/status/`. Unattended: no quote was created from it, or its quote was deleted.
 * @summary How many landing quote requests are unattended.
 */
 billingV1QuoteRequestsStatusRetrieve<TData = QuoteRequestStatusResponseV1>( options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteRequestsStatusRetrieve<TData = QuoteRequestStatusResponseV1>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteRequestsStatusRetrieve<TData = QuoteRequestStatusResponseV1>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteRequestsStatusRetrieve<TData = QuoteRequestStatusResponseV1>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/quote_requests/status/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/quote_requests/status/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/billing/quote_requests/status/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type BillingV1QuoteRequestsListClientResult = NonNullable<CursorPaginatedQuoteRequestResponseV1>
export type BillingV1QuoteRequestsCreateClientResult = NonNullable<QuoteRequestReceiptResponseV1>
export type BillingV1QuoteRequestsRetrieveClientResult = NonNullable<QuoteRequestResponseV1>
export type BillingV1QuoteRequestsDestroyClientResult = NonNullable<void>
export type BillingV1QuoteRequestQuotesCreateClientResult = NonNullable<QuoteResponseV1>
export type BillingV1QuoteRequestsStatusRetrieveClientResult = NonNullable<QuoteRequestStatusResponseV1>
